<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qe7aGR/tc-custom/9780802194497.jpg?1726519188615" alt="This image is the cover for the book Birdman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Birdman
      </h1>
      <p class="bookDescription body article font2">
        <b>A serial killer stalks the streets of London in this “top-notch debut thriller”—the first Jack Caffery novel from the acclaimed author of <i>Gone</i> (<i>Kirkus Reviews</i>).</b><br/>  <br/> In his first case as lead investigator with London’s murder squad, Det. Inspector Jack Caffery is called on to investigate the murder of a young woman whose body has been discovered near the Millennium Dome in Greenwich, southeast London.<br/>  <br/> Mutilated beyond recognition, the victim is soon joined by four others discovered in the same area—all female and all ritualistically murdered. And when the postmortem examination reveals a gruesome signature connecting the victims, Caffery realizes exactly what he’s dealing with—a dangerous serial killer.<br/>  <br/> A finalist for the Edgar Award, <i>Birdman</i> explores the darkest reaches of the human mind and introduces a fascinating detective to the world of British crime fiction.<br/>  <br/> “Treading the grisly path blazed by Thomas Harris in 1981 with <i>Red Dragon</i>, promising newcomer Hayder crafts a blood-curdlingly creepy debut thriller.” —<i>Publishers Weekly</i>, starred review<br/>  <br/> “A deftly plotted assault on the nerves . . . Birdman preys on the reader’s expectations expertly, and Hayder handles her story’s complicated time scheme with enviable assurance. Graphic, disturbing, splendidly readable.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mo Hayder
      </h2>
      
      <p class="authorDescription body article">Mo Hayder has worked as a filmmaker, Tokyo nightclub hostess, and English language teacher in Asia. She is also the author of <I>Birdman</I>; <I>The Treatment</I>; <I>The Devil of Nanking</I>, winner of the<I> Elle Magazine</I> crime fiction prize; <I>Pig Island</I>, shortlisted for the Barry Award for Best British Crime Novel; <I>Ritual</I>, shortlisted both for the CWA Ian Fleming Steel Dagger award and for the coveted Theakstons Old Peculier Crime Novel of the Year Award; <I>Skin</I>; and <I>Gone</I>; as well as the winner of the 2011 Crime Writers' Association Dagger in the Library award for outstanding body of work. She lives in England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5afa8236